var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoomKey = function SvgRoomKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#roomKey_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.195 9.906a.36.36 0 0 1-.34-.239A4.974 4.974 0 0 1 8.55 3.39a.363.363 0 1 1 .288.667 4.25 4.25 0 0 0-2.302 5.36.363.363 0 0 1-.341.489"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.569 0h-9.913A1.3 1.3 0 0 0 9.43.872l-.865 2.473.87 2.567c.179.528.674.883 1.231.883h9.904a.93.93 0 0 0 .93-.93V.93a.93.93 0 0 0-.93-.93m-8.385 4.568a1.17 1.17 0 1 1 0-2.341 1.17 1.17 0 0 1 0 2.341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.29 3.783a1.17 1.17 0 0 1-2.273-.297 1.3 1.3 0 0 1-.407-.587L9.753.365c-.144.138-.256.31-.325.507l-.864 2.473.87 2.567c.178.528.674.884 1.231.884h9.904a.93.93 0 0 0 .93-.93V3.782zM14.885 15.513l3.2 7.931-1.212.49a.246.246 0 0 1-.32-.136l-3.11-7.704-.185-.832 1.24-.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.333 11.298a.844.844 0 0 1-.467 1.099l-1.72.694-.645.255-.697-1.552.887-.34 1.544-.622a.84.84 0 0 1 1.098.466M10.4 12.257c.201.092.288.33.195.53l-.345.743a.4.4 0 0 1-.53.194l-2.991-1.389a.4.4 0 0 1-.195-.53l.346-.743a.4.4 0 0 1 .53-.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.535 22.49a.34.34 0 0 1-.19.446l-1.26.508-.526-1.307 1.259-.508a.343.343 0 0 1 .446.19zM18.506 19.94a.34.34 0 0 1-.19.445l-1.26.508-.527-1.307 1.26-.508a.343.343 0 0 1 .446.19zM16.815 17.114a.337.337 0 0 1 .188.508l-.783 1.198-.86-2.129zM14.787 10.083a.364.364 0 0 1-.335-.503 4.246 4.246 0 0 0-3.145-5.8.363.363 0 0 1 .133-.714 4.972 4.972 0 0 1 3.683 6.792.36.36 0 0 1-.336.225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.393 12.649a3.49 3.49 0 1 1-6.98 0 3.49 3.49 0 0 1 6.98 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.807 11.88c0-1.097.507-2.075 1.298-2.715a3.49 3.49 0 1 0 1.989 6.2 3.49 3.49 0 0 1-3.287-3.484"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.333 11.298a.844.844 0 0 1-.467 1.099l-1.72.694-.645.255-.697-1.552.887-.34 1.544-.622a.84.84 0 0 1 1.098.466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m10.978 12.18.31.691a5 5 0 0 0 1.07-.289 5 5 0 0 0 1.929-1.37q0-.003.003-.004a.84.84 0 0 0-.595-.424 4.215 4.215 0 0 1-2.718 1.396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M11.535 11.358 7.411 9.443a1.286 1.286 0 0 0-1.708.624l-1.027 2.214a1.286 1.286 0 0 0 .625 1.707l1.02.474-3.76 8.091a.31.31 0 0 0-.002.26l.451 1.003a.31.31 0 0 0 .377.17l1.02-.316a.31.31 0 0 0 .19-.167l1.01-2.168-.338-.606.685-.142.26-.562-.337-.607.685-.141.261-.563-.338-.606.685-.142 1.188-2.558 1.066.495c.645.3 1.41.02 1.708-.625l1.028-2.213a1.286 1.286 0 0 0-.625-1.707"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.4 12.257c.201.092.288.33.195.53l-.345.743a.4.4 0 0 1-.53.194l-2.991-1.389a.4.4 0 0 1-.195-.53l.346-.743a.4.4 0 0 1 .53-.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m10.4 12.257-.13-.06a4.24 4.24 0 0 1-2.82-1.31l-.04-.02a.4.4 0 0 0-.53.194l-.086.185a4.97 4.97 0 0 0 3.731 1.685h.003l.067-.144a.4.4 0 0 0-.195-.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.355 11.77v-.646a4.224 4.224 0 0 1-2.83 1.08 4.24 4.24 0 0 1-2.19-.607v.826c.674.33 1.42.507 2.19.507a4.95 4.95 0 0 0 3.192-1.16z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "roomKey_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgRoomKey;